import { useEffect, useMemo, type ReactNode } from 'react';
import {
  IconStyleContext,
  type IconStyle,
  type IconStyleContextValue,
} from './icon-style.context';
import { IconStylePreferenceContext } from './icon-style-preference.context';
import { useIconStylePreference } from './use-icon-style-preference.hook';
import './candy-clerk.css';

/**
 * Chooses how every icon in the app is drawn: the user's choice in
 * Appearance, Candy by default. Signed out, icons are Plain: Lucide icons in
 * the text colour.
 */
export function IconStyleProvider({ children }: { children: ReactNode }) {
  const preference = useIconStylePreference();
  const wanted: IconStyle = preference.style;

  const value = useMemo<IconStyleContextValue>(
    () => ({ style: wanted }),
    [wanted]
  );

  // Lets CSS reach icons the app does not draw itself (Clerk's panels).
  useEffect(() => {
    document.documentElement.dataset.iconStyle = value.style;
  }, [value.style]);

  return (
    <IconStylePreferenceContext.Provider value={preference}>
      <IconStyleContext.Provider value={value}>
        {children}
      </IconStyleContext.Provider>
    </IconStylePreferenceContext.Provider>
  );
}
